import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    onSubmitting: false,
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.BANNER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.BANNER_CREATE_ACTION:
            return { ...state, isFetching: true, onSubmitting: false, isSubmit: true };
        case Types.BANNER_UPDATE_ACTION:
            return { ...state, isFetching: true, onSubmitting: false, isSubmit: true };
        case Types.BANNER_DELETE_ACTION:
            return { ...state, isFetching: true, isSubmit: true };
        case Types.BANNER_GET_UPDATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.BANNER_LIST_SUCCESS:
            return { ...state, isFetching: false, data: action.banners, isSubmit: false };
        case Types.BANNER_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingUpdate: false, dataUpdate: action.dataUpdate };
        case Types.BANNER_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.BANNER_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.BANNER_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.BANNER_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.BANNER_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.BANNER_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.BANNER_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isSubmit: false };
        default:
            return state;
    }
}
